import request from 'utils/request';

import {
  FETCH_CUSTOM_RULES,
  FETCH_SMART_LIMITS,
  GET_RISK_SHIELD_FLAGGED_AND_BLOCKED_TXNS_URL,
  GET_TRANSACTIONS_SCANNED_URL,
} from 'constants/url';
import { CUSTOM_BASE_PATH_TYPES } from 'utils/constants';

export const getFlaggedAndBlockedTxns = async (queryObj: any) => {
  try {
    const { url, method } = GET_RISK_SHIELD_FLAGGED_AND_BLOCKED_TXNS_URL;
    const reqOptions = {
      method,
      queryString: queryObj,
      directResponseReturn: true,
    };
    const response = await request(
      url,
      reqOptions,
      '',
      CUSTOM_BASE_PATH_TYPES.RISKSHIELD_BASE_PATH,
    );
    return response;
  } catch (err) {
    return [];
  }
};

export const getTransactionsScanned = async (queryObj: any) => {
  try {
    const { url, method } = GET_TRANSACTIONS_SCANNED_URL;
    const reqOptions = {
      method,
      body: JSON.stringify(queryObj),
      directResponseReturn: true,
    };
    const response = await request(
      url,
      reqOptions,
      '',
      CUSTOM_BASE_PATH_TYPES.RISKSHIELD_BASE_PATH,
    );
    return response;
  } catch (err) {
    return err;
  }
};

export const getRecommendedSmartRules = async () => {
  try {
    const { url, method } = FETCH_CUSTOM_RULES;
    const reqOptions = {
      method,
      directResponseReturn: true,
    };
    const response = await request(
      url,
      reqOptions,
      '',
      CUSTOM_BASE_PATH_TYPES.RISKSHIELD_BASE_PATH,
    );
    return response;
  } catch (err) {
    return err;
  }
};

export const getCustomCreatedSmartRules = async ({ queryObj }) => {
  try {
    const { url, method } = FETCH_SMART_LIMITS;
    const reqOptions = {
      method,
      queryString: queryObj,
      directResponseReturn: true,
    };
    const response = await request(
      url,
      reqOptions,
      '',
      CUSTOM_BASE_PATH_TYPES.RISKSHIELD_BASE_PATH,
    );
    return response;
  } catch (err) {
    return err;
  }
};
